module.exports = __webpack_public_path__ + "img/SKMJ_up2.64b03517.png";